// กติกาเดียวกับศูนย์แจ้งเตือนสถานศึกษา (HRvec_api/college_notification_center.php):
// กำหนดการที่เลยวันสิ้นสุดแล้วไม่แสดง แม้สวิตช์ enable ยังเปิดค้างอยู่ — ผู้ใช้ดำเนินการไม่ได้แล้ว
// และการ์ดที่นับถอยหลังเป็น 00 ทำให้สับสน
//
// "วันสิ้นสุด" = วันที่ช้าที่สุดระหว่างวันปิดระบบกับวันปิดแนบไฟล์ (ยังแนบไฟล์ได้ถึงวันนั้น)
// รองรับคอลัมน์ของทุกตารางกำหนดการ: period_college_stop / period_college_attactmentstop,
// period_stop / period_stop_file, period_sedirector_stop, period_vecprovince_stop, periodAssTeachStop
// วันสิ้นสุดวันนี้ยังแสดง (ระบบปิดเย็นวันนั้น)

const STOP_KEY = /(_stop|Stop|attactmentstop|_stop_file)$/;

function toDate(v) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v || ""));
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
}

/** วันสิ้นสุดที่มีผลของกำหนดการ (Date) หรือ null ถ้าไม่มีวันที่ที่อ่านได้ */
export function periodEndDate(period) {
  if (!period || typeof period !== "object" || Array.isArray(period)) return null;
  let end = null;
  Object.keys(period).forEach(k => {
    if (!STOP_KEY.test(k)) return;
    const d = toDate(period[k]);
    if (d && (!end || d > end)) end = d;
  });
  return end;
}

/**
 * คืนข้อมูลกำหนดการเดิมถ้ายังไม่เลยวันสิ้นสุด ไม่งั้นคืน {} (การ์ดที่เช็ก enable จะไม่แสดงเอง)
 * ข้อมูลที่ไม่ใช่ object เดี่ยว (array/ค่าว่าง) คืนตามเดิม
 */
export function activePeriod(period) {
  if (!period || typeof period !== "object" || Array.isArray(period)) return period || {};
  const end = periodEndDate(period);
  if (!end) return period;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return end < today ? {} : period;
}
